import { ChangeDetectionStrategy, Component, InputSignal, OutputEmitterRef, input, output } from '@angular/core';

import { DatePipesModule } from '@core/shared/util';
import {
  CatalogCovinBadgeComponent,
  CatalogTypeIconComponent,
  EntityItemActionButtonComponent,
  EntityItemsModule,
} from '@core/ui';

import { SortableCatalog } from '../models';
import { RemoveButtonComponent } from '../remove-button/remove-button.component';

import { CatalogItemFooterComponent, UpdateCatalog } from './catalog-item-footer/catalog-item-footer.component';

@Component({
  selector: 'mp-sortable-catalog',
  templateUrl: './sortable-catalog.component.html',
  styleUrl: './sortable-catalog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    'class': 'mp-sortable-catalog',
    '[class.mp-sortable-catalog--focused]': 'focus()',
  },
  imports: [
    CatalogCovinBadgeComponent,
    CatalogTypeIconComponent,
    DatePipesModule,
    EntityItemsModule,
    RemoveButtonComponent,
    EntityItemActionButtonComponent,
    CatalogItemFooterComponent,
  ],
})
export class SortableCatalogComponent {
  readonly catalog: InputSignal<SortableCatalog> = input.required<SortableCatalog>();
  readonly allowWrite: InputSignal<boolean> = input<boolean>(false);
  readonly allowNavigation = input(true);

  readonly focus: InputSignal<boolean> = input<boolean>(false);

  readonly itemRemoved: OutputEmitterRef<SortableCatalog> = output<SortableCatalog>();
  readonly itemUpdated: OutputEmitterRef<UpdateCatalog> = output<UpdateCatalog>();
  readonly industryCatalogClicked: OutputEmitterRef<string> = output<string>();

  emitItemRemoved(catalog: SortableCatalog): void {
    this.itemRemoved.emit(catalog);
  }

  emitIndustryCatalogUpdate(updateCatalog: UpdateCatalog): void {
    this.itemUpdated.emit(updateCatalog);
  }

  emitIndustryCatalogClicked(id: string): void {
    this.industryCatalogClicked.emit(id);
  }
}
